import React, {useContext} from 'react';
import classNames from 'classnames';
import { ListingAppContext } from '../contexts';

export const Footer = ({
    contactUrl,
    tosUrl,
    privacyUrl,
    doNotSellUrl,
    logo,
    copyrightName,
    messages,
    className,
    versionIdentifier = '',
}) => {
    const { t } = useContext(ListingAppContext);
    const year = new Date().getFullYear();

    return (
        <footer className={classNames('footer', className)}>
            <div className='footer-container org-listing__container'>
                <div className='footer-main'>
                    {!!logo && (
                        <div className="footer-branding">
                            <a
                                href={contactUrl || '#'}
                                className="footer-branding-image"
                                style={{ backgroundImage: `url(${logo})` }}
                            >
                                <span className="sr-only">{copyrightName}</span>
                            </a>
                        </div>
                    )}
                    <ul className='footer-links clean'>
                        {!!contactUrl && (
                            <li><a href={contactUrl} target="_blank" rel="noopener noreferrer">{t('support')}</a></li>
                        )}
                        {!!tosUrl && (
                            <li><a href={tosUrl} target="_blank" rel="noopener noreferrer">{t('terms_of_service')}</a></li>
                        )}
                        {!!privacyUrl && (
                            <li><a href={privacyUrl} target="_blank" rel="noopener noreferrer">{t('privacy_policy')}</a></li>
                        )}
                        {!!doNotSellUrl && (
                            <li><a href={doNotSellUrl} target="_blank" rel="noopener noreferrer">{t('do_not_sell_or_share')}</a></li>
                        )}
                    </ul>
                    {!!copyrightName && (<p className='footer-copyright'>©{year} {copyrightName}</p>)}
                    {!!versionIdentifier && (
                        <p className='footer-copyright' style={{ textAlign: 'center' }}>
                          {versionIdentifier}
                        </p>
                    )}
                </div>
                {!!messages && (<p>{messages}</p>)}
            </div>
        </footer>
    );
}
